
export const CDN_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const LOGO_URL = "https://raw.githubusercontent.com/dawsonsgeek/react-restaurant/main/src/images/logo.png";
  // "https://www.logodesign.net/logo/smoking-burger-with-lettuce-3624ld.png";
  // "https://github.com/dawsonsgeek/react-restaurant/blob/main/src/images/smoking-burger-with-lettuce-3624ld-removebg-preview.png";
  // "https://raw.githubusercontent.com/dawsonsgeek/react-restaurant/main/src/images/smoking-burger-with-lettuce-3624ld-removebg-preview.png";

export const MENU_API =   "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.62448069999999&restaurantId=";

// "https://corsproxy.io/?https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9351929&lng=77.62448069999999&page_type=DESKTOP_WEB_LISTING&restaurantId=";

  // "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.62448069999999&restaurantId=";
// "https://corsproxy.io?https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9351929&lng=77.62448069999999&page_type=DESKTOP_WEB_LISTING"